export default __webpack_public_path__ + "static/media/power3.6bdecf22.svg";